import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

const sizes = {
  sm: "size-4",
  md: "size-6",
  lg: "size-8",
} as const;

export interface SpinnerProps {
  size?: keyof typeof sizes;
  /** Accessible label; also shown as visible text when `showLabel`. */
  label?: string;
  showLabel?: boolean;
  className?: string;
}

/**
 * Indeterminate loading spinner. Respects reduced-motion via the global CSS
 * rule that neutralizes animations (globals.css). Always carries an a11y label.
 */
export function Spinner({
  size = "md",
  label = "Loading",
  showLabel = false,
  className,
}: SpinnerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "inline-flex items-center gap-2 text-muted-foreground",
        className,
      )}
    >
      <Loader2 className={cn("animate-spin", sizes[size])} aria-hidden="true" />
      {showLabel ? (
        <span className="text-sm">{label}</span>
      ) : (
        <span className="sr-only">{label}</span>
      )}
    </div>
  );
}
